export default __webpack_public_path__ + "static/media/partnerLeftPolygon.891d4780.svg";